import { Masonry } from '@mui/lab';
import WatchlistItem from './WatchlistItem';

const GridView = ({ watchlists, accessToken, getAllWatchlists }) => {
  return (
    <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={2}>
      {watchlists?.map((d) => (
        <WatchlistItem
          key={d.name}
          tickers={d?.tickers && d?.tickers !== "" ? JSON.parse(d.tickers) : []}
          watchlistName={d?.name}
          accessToken={accessToken}
          isSystemDefault={d?.isSystemDefault}
          getAllWatchlists={getAllWatchlists}
        />
      ))}
    </Masonry>
  );
};

export default GridView;
